import { useEffect } from 'react';
import _ from 'lodash';
import useResourceTypes from './useResourceTypes';

const useRestoreResourceTypeIfNotExists = ({
  restoreFn = _.noop,
  resourceType
} = {}) => {
  const { resourceTypes } = useResourceTypes();

  const restoreResourceTypeIfNotExists = () => {
    if (!resourceTypes[resourceType.key]) restoreFn();
  };

  useEffect(() => {
    restoreResourceTypeIfNotExists();
  }, [resourceTypes, resourceType]);
};

export default useRestoreResourceTypeIfNotExists;
